var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"app-sidebar"},[_c('div',{staticClass:"app-sidebar__wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }